import { BranchType, DepartmentType, DesignationType, DoctorOverview, LanguageType, PatientOverview } from "@/types"
import apiClient from "../api/client"
import { CreateDoctorUserFormData, CreatePatientUserFormData } from "../validations/auth";
import { Appointment } from "@/types/appointment";

export const userService = {
    async getDoctors(): Promise<DoctorOverview[]> {
        const response = await apiClient.get('/user-management/users/doctors')
        console.log('Fetched doctors:', response.data.data);
        return response.data.data
    },
    async getDoctor(id: string): Promise<DoctorOverview> {
        const response = await apiClient.get(`/user-management/users/doctor/${id}`)
        return response.data.data
    },
    async getDepartment(): Promise<DepartmentType[]> {
        const response = await apiClient.get(`/departments`)
        return response.data.data
    },
    async getDesignation(): Promise<DesignationType[]> {
        const response = await apiClient.get(`/designations`)
        return response.data.data
    },
    async getLanguages(): Promise<LanguageType[]> {
        const response = await apiClient.get(`/system-settings/language/languages`)
        return response.data.data
    },
    async getBranch(): Promise<BranchType[]> {
        const response = await apiClient.get(`/branches`)
        return response.data.data
    },
    async createDoctor(data: CreateDoctorUserFormData): Promise<{ message: string; data: DoctorOverview | null; status_code: number; errors? :{ [key: string]: [] } }> {
        try {
            const response = await apiClient.post('/user-management/users/doctor', data)
            console.log(response)
            return {
                message: "Success",
                status_code: response.status,
                data: {...response.data}
            }
        } catch (error: any) {
            if(error.response && error.response.data.message.includes("has already been taken.")) {
                return {
                    message: error.response.data.message,
                    data: null,
                    status_code: 409,
                    errors: error.response.data.errors
                }
            }
            throw new Error(error.response?.data?.message || 'Failed to create doctor')
        }
    },
    async updateDoctor(data: CreateDoctorUserFormData, id: string): Promise<{ message: string; data: DoctorOverview | null; status_code: number; errors? :{ [key: string]: [] } }> {
        try {
            const response = await apiClient.put(`/user-management/users/doctor/${id}`, data)
            console.log(response)
            return {
                message: "Success",
                status_code: response.status,
                data: {...response.data}
            }
        } catch (error: any) {
            if(error.response && error.response.data.message.includes("has already been taken.")) {
                return {
                    message: error.response.data.message,
                    data: null,
                    status_code: 409,
                    errors: error.response.data.errors
                }
            }
            throw new Error(error.response?.data?.message || 'Failed to update doctor')
        }
    },
    async createPatient(data: CreatePatientUserFormData): Promise<{ message: string; data: PatientOverview | null; status_code: number; errors? :{ [key: string]: [] } }> {
        try {
            const response = await apiClient.post('/user-management/users/patient', data)
            return {
                message: "Success",
                status_code: response.status,
                data: {...response.data}
            }
        } catch (error: any) {
            if(error.response && error.response.data.message.includes("has already been taken.")) {
                return {
                    message: error.response.data.message,
                    data: null,
                    status_code: 409,
                    errors: error.response.data.errors
                }
            }
            throw new Error(error.response?.data?.message || 'Failed to create patient')
        }
    },
    async updatePatient(data: CreatePatientUserFormData, id: string): Promise<{ message: string; data: PatientOverview | null; status_code: number; errors? :{ [key: string]: [] } }> {
        try {
            const response = await apiClient.put(`/user-management/users/patient/${id}`, data)
            console.log(response)
            return {
                message: "Success",
                status_code: response.status,
                data: {...response.data}
            }
        } catch (error: any) {
            if(error.response && error.response.data.message.includes("has already been taken.")) {
                return {
                    message: error.response.data.message,
                    data: null,
                    status_code: 409,
                    errors: error.response.data.errors
                }
            }
            throw new Error(error.response?.data?.message || 'Failed to update patient')
        }
    },
    async getPatients(): Promise<PatientOverview[]> {
        const response = await apiClient.get('/user-management/users/patients')
        return response.data.data
    },
    async getActivePatients(): Promise<PatientOverview[]> {
        const response = await apiClient.get('/user-management/users/active-patients')
        return response.data.data
    },
    async getPatient(id: string): Promise<PatientOverview> {
        const response = await apiClient.get(`/user-management/users/patient/${id}`)
        return response.data.data
    },
    async getPatientAppointments(id: string): Promise<Appointment[]> {
        const response = await apiClient.get(`/user-management/users/patient/${id}/appointments`)
        return response.data.appointments
    },
}